import { inject } from '@angular/core';
import { type CanActivateFn, type ActivatedRouteSnapshot, type RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth';

/**
 * Functional auth guard that checks if user is authenticated
 * Redirects to login with return URL if not authenticated
 */
export const authGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService: AuthService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }
  // Store the attempted URL for redirecting after login
  authService.login(state.url);

  return false;
};
